export default __webpack_public_path__ + "static/media/opensupports.b56dfdd0.svg";